import React, { useEffect, useState } from "react";
import BarraSuperior from "./components/barraSuperior/BarraSuperior";
import "./Menu.css";
import "./MenuRedesign.css";
import { useDispatch, useSelector } from "react-redux";
import { useKeycloak } from "@react-keycloak/web";

import { LOCAL_STORAGE_KEY__SELECTED_SECTION, SECTION_TYPE_SCREEN, MENU_MOBILE_WIDTH, MENU_DISPLAY_TOP } from "../../Utils/Constants";
import { selectedSectionActionCreator } from "../../actions/commonActions";
import { MULTITENANT_CONSTANTS, TENANT } from "../../Resources/Multitenant/tenantConstants";
import { NotificationsProvider } from "./Context/NotificationsProvider";
import MenuComponent from "./components/menuComponent/MenuComponent";
import { useHistory } from "react-router-dom";
import {
  URL_NAME_EXCEPTIONS,
  URL_PATH_NAMES,
  URL_SCREEN,
  URL_SECTION
} from "../../Components/Routes/Location";
import { generateSlug, getMenuClassName, manageBodyClass, cleanupBodyClass } from "../../Utils/utils";

const MenuApiComponent = (props) => {
  const dispatch = useDispatch();
  const { keycloak } = useKeycloak();
  const history = useHistory();

  const sectionsMenu = useSelector((state) => state.commonState.sectionsMenu);
  const menuDisplay = useSelector((state) => state.commonState.menuDisplay);
  const isLoginRequired = MULTITENANT_CONSTANTS[TENANT].showLoginButton;
  const [renderMobileVersion, setRenderMobileVersion] = useState(null);

  useEffect(() => {
  if (!keycloak?.authenticated && !isLoginRequired) {
    const currentPath = history.location.pathname;
    const protectedRoutes = ["/profile", "/ranking"];

    if (protectedRoutes.some((route) => currentPath.startsWith(route))) {
      history.replace("/home");
    }
  }
}, [keycloak?.authenticated, history, isLoginRequired]);

const handleResize = () => {
    setRenderMobileVersion(window.innerWidth <= MENU_MOBILE_WIDTH);
  };

  // FIX: Inicializa renderMobileVersion al montar para detectar móvil/desktop correctamente
  useEffect(() => {
    handleResize();
  }, [])

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.innerWidth]);

  const handleToggleNotifications = () => {};

  const handleChangeSection = (s) => {
    if (!s?.type && !s?.name) return;
    if (s.type === SECTION_TYPE_SCREEN) {
      localStorage.setItem(LOCAL_STORAGE_KEY__SELECTED_SECTION, JSON.stringify(s));
      dispatch(selectedSectionActionCreator(s));
      if (URL_NAME_EXCEPTIONS.includes(s.name?.toUpperCase())) {
        history.push(`/${s.name.toLowerCase()}`);
      } else {
        history.push(`${URL_SCREEN}/${generateSlug(s.name)}/${s.screenId}`);
      }
    } else if (URL_PATH_NAMES.includes(s.type?.toUpperCase())) {
      history.push(`/${s.type}`);
    } else if (s.name) {
      history.push(`${URL_SECTION}/${generateSlug(s.name)}`);
    }
  };
  const baseMenuClassName = getMenuClassName(history.location.pathname, renderMobileVersion);
  // El menú top solo aplica en desktop
  const isTopMenuDesktop = menuDisplay === MENU_DISPLAY_TOP && !renderMobileVersion;
  const menuClassName = isTopMenuDesktop 
    ? `${baseMenuClassName} Menu--top-container` 
    : baseMenuClassName;
  
  React.useEffect(() => {
    manageBodyClass(history.location.pathname, renderMobileVersion);
    return () => {
      cleanupBodyClass();
    };
  }, [history.location.pathname, renderMobileVersion]);

  return (
    <div className={menuClassName}>
      {sectionsMenu && (
        <div>
          <BarraSuperior
            sections={sectionsMenu}
            className={`BarraSuperiorUsuario ${
              MULTITENANT_CONSTANTS[TENANT].sticky && "sticky"
            }`}
            handleChangeSection={handleChangeSection}
            renderMobileVersion={renderMobileVersion}
            {...props}
          />
          <NotificationsProvider>
            <MenuComponent
              handleToggleNotifications={handleToggleNotifications}
              renderMobileVersion={renderMobileVersion}
              handleChangeSection={handleChangeSection}
            />
          </NotificationsProvider>
        </div>
      )}
    </div>
  );
};

export default MenuApiComponent;
